/**
 * The development brain's own section (R7), now the Arendusaju tab of
 * Kliendiotsing.
 *
 *   /prospects/brain           - every company the brain has looked at
 *   /prospects/brain/:domain   - one of them, on its own address
 *
 * (The R7 addresses `/brain` and `/brain/:domain` still work: the router sends
 * them here with the domain intact, see `prospecting/LegacyRedirect.tsx`.)
 *
 * Keyed by DOMAIN and not by register code, like every other door into this
 * feature: a scan lead can have no register code at all, and those are exactly
 * the sites the tool was built for.
 *
 * This tab and the follow-up queue are still two views and not one list with a
 * filter. They answer different questions: this one is the tool's memory
 * ("what do we know about this company"), the queue is a promise somebody made
 * on the phone ("who did I say I would call back"). What changed is that they
 * are now neighbouring tabs of one page instead of two unrelated sidebar rows.
 */
import { Navigate, Route, Routes } from "react-router-dom";
import type { StaffUser } from "../../../lib/auth";
import { stepPath } from "../prospecting/steps";
import { BrainListPage } from "./BrainListPage";
import { BrainDetailPage } from "./BrainDetailPage";

export function BrainSection({ user }: { user: StaffUser }) {
  return (
    <Routes>
      <Route index element={<BrainListPage user={user} />} />
      <Route path=":domain" element={<BrainDetailPage user={user} />} />
      <Route path="*" element={<Navigate to={stepPath("brain")} replace />} />
    </Routes>
  );
}
